import { useEffect, useState } from 'react';

// this hooks is the replacement for the isSsr() function from Monolu, avoid it since it uses window to detect client side rendering and will conflict with next ssr
export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return isClient;
};
